const ListingTypes = {
  FETCH_LISTING_REQUEST: 'FETCH_LISTING_REQUEST',
  FETCH_LISTING_SUCCESS: 'FETCH_LISTING_SUCCESS',
  FETCH_LISTING_ERROR: 'FETCH_LISTING_ERROR',
  RESET_LISTING: 'RESET_LISTING',
  SET_LISTING_LOADING: 'SET_LISTING_LOADING',
  SET_LISTING_LOADING_TRANSITION: 'SET_LISTING_LOADING_TRANSITION',
  FETCH_ALL_LISTS_REQUEST: 'FETCH_ALL_LISTS_REQUEST',
  FETCH_ALL_LISTS_SUCCESS: 'FETCH_ALL_LISTS_SUCCESS',
  FETCH_ALL_LISTS_ERROR: 'FETCH_ALL_LISTS_ERROR',
  FETCH_HEADER_SEARCH_REQUEST: 'FETCH_HEADER_SEARCH_REQUEST',
  FETCH_HEADER_SEARCH_SUCCESS: 'FETCH_HEADER_SEARCH_SUCCESS',
  FETCH_HEADER_SEARCH_ERROR: 'FETCH_HEADER_SEARCH_ERROR',
  RESET_HEADER_SEARCH: 'RESET_HEADER_SEARCH',
  CHANGE_LISTING_STATUS_SUCCESS: 'CHANGE_LISTING_STATUS_SUCCESS',
  CHANGE_LISTING_STATUS_ERROR: 'CHANGE_LISTING_STATUS_ERROR',
  RESET_LISTING_STATUS_CHANGED: 'RESET_LISTING_STATUS_CHANGED',
  FETCH_LISTING_IDS_BY_USER_REQUEST: 'FETCH_LISTING_IDS_BY_USER_REQUEST',
  FETCH_LISTING_IDS_BY_USER_SUCCESS: 'FETCH_LISTING_IDS_BY_USER_SUCCESS',
  FETCH_LISTING_IDS_BY_USER_ERROR: 'FETCH_LISTING_IDS_BY_USER_SUCCESS',
  SET_WORKFLOW_STATUS_ID: 'SET_WORKFLOW_STATUS_ID',
  SET_LOCKED_BY_USER_ID: 'SET_LOCKED_BY_USER_ID',
  SET_IS_READ_ONLY: 'SET_IS_READ_ONLY',
  POSTPONE_LISTING_REQUEST: 'POSTPONE_LISTING_REQUEST',
  POSTPONE_LISTING_SUCCESS: 'POSTPONE_LISTING_SUCCESS',
  POSTPONE_LISTING_ERROR: 'POSTPONE_LISTING_ERROR',
  RESET_WORKFLOW_STATUS_CHANGED: 'RESET_WORKFLOW_STATUS_CHANGED',
  RESET_LISTING_ERROR: 'RESET_LISTING_ERROR',
  FETCH_REASSIGN_RECIPIENTS_ERROR: 'FETCH_REASSING_RECIPIENTS_ERROR',
  FETCH_REASSIGN_RECIPIENTS_SUCCESS: 'FETCH_REASSIGN_RECIPIENTS_SUCCESS',
  REASSIGN_LISTING_REQUEST: 'REASSIGN_LISTING_REQUEST',
  REASSIGN_LISTING_SUCCESS: 'REASSIGN_LISTING_SUCCESS',
  REASSIGN_LISTING_ERROR: 'REASSIGN_LISTING_ERROR',
  REORDER_PUPPY_MEDIA: 'REORDER_PUPPY_MEDIA',
  UPDATE_PARENT: 'UPDATE_PARENT',
  SET_LISTING_PARENTS: 'SET_LISTING_PARENTS',
  SET_PUPPY_INVENTORY_STATUS: 'SET_PUPPY_INVENTORY_STATUS',
  UPDATE_SINGLE_PARENT: 'UPDATE_SINGLE_PARENT',
  CHECK_MEDIA_TO_EDIT: 'CHECK_MEDIA_TO_EDIT',

  SET_LISTING_STATUS_REASON: 'SET_LISTING_STATUS_REASON',
  SET_LOADING_PRICE_CALCULATION: 'SET_LOADING_PRICE_CALCULATION',
};
export default ListingTypes;
